__turbopack_context__.v({
  "authorBlock": "CardTestimonial-module-scss-module__X2pJUG__authorBlock",
  "authorDescription": "CardTestimonial-module-scss-module__X2pJUG__authorDescription",
  "authorName": "CardTestimonial-module-scss-module__X2pJUG__authorName",
  "blueBlockTestimonial": "CardTestimonial-module-scss-module__X2pJUG__blueBlockTestimonial",
  "blueSolidIconBlockTestimonial": "CardTestimonial-module-scss-module__X2pJUG__blueSolidIconBlockTestimonial",
  "iconWrapper": "CardTestimonial-module-scss-module__X2pJUG__iconWrapper",
  "imageBlock": "CardTestimonial-module-scss-module__X2pJUG__imageBlock",
  "img": "CardTestimonial-module-scss-module__X2pJUG__img",
  "innerBlock": "CardTestimonial-module-scss-module__X2pJUG__innerBlock",
  "largeQuote": "CardTestimonial-module-scss-module__X2pJUG__largeQuote",
  "lineBlock": "CardTestimonial-module-scss-module__X2pJUG__lineBlock",
  "secondaryQuote": "CardTestimonial-module-scss-module__X2pJUG__secondaryQuote",
  "testimonial": "CardTestimonial-module-scss-module__X2pJUG__testimonial",
  "textBlock": "CardTestimonial-module-scss-module__X2pJUG__textBlock",
  "textWrapper": "CardTestimonial-module-scss-module__X2pJUG__textWrapper",
  "whiteBlockTestimonial": "CardTestimonial-module-scss-module__X2pJUG__whiteBlockTestimonial",
});
